<template>
  <div class="report-conversions-adjustment-dialog">
    <portal to="base-modal">
      <base-modal @closed_requested="close_dialog">
        <form @submit.prevent="save_conversion_adjustment" ref="form">
          <h3>{{ media_planning.title }}</h3>
          <h4>
            <channel-icon :channel_title="campaign.channel_title"></channel-icon>
            {{ campaign.title }}
            /
            {{ report.platform_title }}
            /
            {{ format_date_time(report.date) }}
          </h4>

          <div v-if="errors" class="callout alert">
            <h5>Error</h5>
            <p v-for="error in errors">{{ error }}</p>
            <button @click.stop="errors = null" class="close-button" aria-label="Dismiss alert" type="button">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <fieldset>
            Korrektur der Conversions
            (<vue-numeric v-model="report.conversions" separator="." decimal-separator="," v-bind:precision=6 v-bind:read-only=true></vue-numeric>)
            um:
            <vue-numeric v-model="conversion_adjustment"
                         v-bind:precision=6
                         :minus="true"
                         type="number"
                         separator=""
                         decimal-separator=","
                         :min="min_adjustment"
                         class="report-conversions-adjustment-dialog--input">
            </vue-numeric>
            auf
            <vue-numeric v-model="report.conversions + conversion_adjustment" separator="." decimal-separator="," v-bind:precision=6 v-bind:read-only=true></vue-numeric>
          </fieldset>

          <div class="report-conversions-adjustment-dialog--actions">
            <button class="report-conversions-adjustment-dialog--button"
                    :class="disabled_button_class"
                    :disabled="loading">
              <i class="fi-save"></i>
              Korrektur speichern
            </button>

            <button @click.stop="close_dialog"
                    :disabled="loading"
                    :class="disabled_button_class"
                    class="report-conversions-adjustment-dialog--button--abort">
              <i class="fi-x"></i>
              Abbrechen
            </button>
          </div>
        </form>
      </base-modal>
    </portal>
  </div>
</template>

<script>
import "./report-conversions-adjustment-dialog.scss"
import BaseModal from "../base-modal/base-modal-app"
import ChannelIcon from "../channel-icon/channel-icon-app"
import VueNumeric from 'vue-numeric'
import moment from "moment"
import axios from "axios"

export default {
  name: "report-conversions-adjustment-dialog",
  props: {
    media_planning: {
      required: true,
    },
    campaign: {
      required: true,
    },
    report: {
      required: true,
    },
  },
  components: {
    BaseModal,
    ChannelIcon,
    VueNumeric,
  },
  data() {
    return {
      conversion_adjustment: this.report.conversion_adjustment,
      loading: false,
      errors: null,
    }
  },
  methods: {
    save_conversion_adjustment() {
      if (this.loading) return
      this.loading = true
      this.errors = null

      axios({
        method: 'post',
        url: `/media_plannings/${this.media_planning.id}/adjust_report_conversions`,
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        data: {
          campaign_id: this.campaign.id,
          campaign_integration_id: this.report.campaign_integration_id,
          date: this.report.date,
          conversion_adjustment: this.conversion_adjustment,
        },
      }).then((_response) => {
        this.loading = false;
        this.close_dialog()
      }).catch(error => {
        this.loading = false;
        this.errors = error.response.data.errors.map(error => error.title)
        console.log("ERROR", error.response.data)
        alert("Error saving conversion adjustment")
      });
    },
    format_date_time(date_time, format = "L") {
      return moment(date_time).format(format)
    },
    close_dialog() {
      this.$emit("closed_requested")
    },
  },
  computed: {
    min_adjustment() {
      return -this.report.conversions
    },
    disabled_button_class() {
      if (this.loading) {
        return "report-conversions-adjustment-dialog--button--disabled"
      }
    },
  },
}
</script>
